import { EuiBasicTable, EuiButtonIcon, EuiHealth, EuiIcon } from "@elastic/eui"
import { useEffect, useState } from "react";
import { useMemo } from "react-window/node_modules/@types/react";
import { formatDateTime } from "../../../../../../shared/utils/fecha";
import { DetalleContent } from "./detalleContent";

interface dataDetalleRequest {IdTipo: string, IdCentro: string}

export const TablaValidaciones = (props:any) =>{

    const {data, onDetalleFilter, onInvalidar, todosValidados, onValidarCG, usrCG, usrDN, validaFinal, tipoContenido} = props;

    const [dataTable, setDataTable] = useState<any>([]);
    const [itemIdToExpandedRowMap, setItemIdToExpandedRowMap] = useState<any>({});
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState('');
  
    useEffect(()=> setDataTable(data),[data])

    const tWidht = '100px';

    const columns = [
        {
          width: '40px',
          isExpander: true,
          render: (item:any) => (
            <EuiButtonIcon
              className='btn-expand-cell'
              onClick={() => onClickDetalle(item)}
              aria-label={(itemIdToExpandedRowMap && itemIdToExpandedRowMap[item.idCentro]) ? 'Collapse' : 'Expand'}
              iconType={(itemIdToExpandedRowMap && itemIdToExpandedRowMap[item.idCentro]) ? 'arrowUp' : 'arrowDown'}
            />
          ),
        },
        {
          width: '70px',
          field: 'idCentro',
          name: 'IdCentro',
          sortable: true,
          render: (centroId: any) => centroId!==null ? centroId : '',
        },
        {
          field: 'descripcion',
          name: 'Nombre',
          sortable: true,
          truncateText: false,
          enlarge: true,
          width: '100%',
        },
        {
          // field: 'subido',
          name: 'Subido',
          // sortable: true,
          width: tWidht,
          render: (item: any) => {
            // const color = (estado == 0 ? 'success' : (estado == 1 ? 'danger' : 'warning'));
            // const label = (estado == 0 ? 'Correcto' : (estado == 1 ? 'Errores' : 'Avisos'));
            const type = (item.subido ? (item.soloCentro ? 'checkInCircleFilled' : 'check') : 'cross');
            const color = (item.subido ? 'success' : 'danger');
            return <EuiIcon type={type} color={color} title={item.soloCentro ? 'Solo Area' : ''} />; //{label}</EuiHealth>;
          },
        },
        {
          // field: 'validado',
          name: 'Validado',
          // sortable: true,
          width: tWidht,
          render: (item:any) => {
            console.log('validado render', item);
            if(item.subido && !item.validado && usrCG){
              return <EuiButtonIcon
                        display='base'
                        onClick={() => onValidarCG(item.idCentro, false)}
                        iconType={'check'}
                      />
            }else{
              const type = (item.validado ? 'check' : 'cross');
              const color = (item.validado ? 'success' : 'danger');
              return <EuiIcon type={type} color={color} />;
            }
            // const type = (validado ? 'check' : 'cross');
            // const color = (validado ? 'success' : 'danger');
            // return <EuiIcon type={type} color={color} />;
          },
        },
        {
          field: 'usuario',
          name: 'Usuario',
          sortable: true,
          truncateText: false,
          enlarge: true,
          width: '100%',
        },
        {
          field: 'fecha',
          name: 'Fecha',
          sortable: true,
          render: (fecha: any) => {
            let vFecha = '';
            if(fecha != null && fecha != undefined) vFecha = formatDateTime(fecha);
            return vFecha;
          },
          truncateText: false,
          enlarge: true,
          width: '100%',
        },
        
        {
          // field: 'validadoCG',
          name: 'Validado CG',
          // sortable: true,
          width: tWidht,
          render: (item:any) => {
            if(item.validado && !item.validadoCG && (!todosValidados || (!validaFinal && usrCG))){
              return <EuiButtonIcon
                        display='base'
                        onClick={() => onValidarCG(item.idCentro, true)}
                        iconType={'check'}
                      />
            }else{
              const type = (item.validadoCG ? 'check' : 'cross');
              const color = (item.validadoCG ? 'success' : 'danger');
              return <EuiIcon type={type} color={color} />;
            }
          },
        },
        {
          field: 'usuarioCG',
          name: 'Usuario',
          sortable: true,
          truncateText: false,
          enlarge: true,
          width: '100%',
        },
        {
          field: 'fechaCG',
          name: 'Fecha',
          sortable: true,
          render: (fecha: any) => {
            let vFecha = '';
            if(fecha != null && fecha != undefined) vFecha = formatDateTime(fecha);
            return vFecha;
          },
          truncateText: false,
          enlarge: true,
          width: '100%',
        },
        {
          width: '70px',
          name: 'Invalidar',
          render: (item:any) => (item.validado && (!todosValidados || (!validaFinal && usrCG))) ? (
            <EuiButtonIcon
              // className='btn-expand-cell'
              display='base'
              onClick={() => onInvalidar(item.idCentro, false)}
              // aria-label={(itemIdToExpandedRowMap && itemIdToExpandedRowMap[item.idImportacion]) ? 'Collapse' : 'Expand'}
              iconType={'cross'}
            />
          ) : null,
        },
      ];

      const onTableChange = ({ sort = {} }) => {
        const { field, direction }:any = sort;
    
        if(direction && direction!=='')
        {
          if(direction === 'desc')
            dataTable.sort((a:any,b:any) => (a[field] > b[field]) ? 1 : ((b[field] > a[field]) ? -1 : 0))
          else
            dataTable.sort((a:any,b:any) => (a[field] < b[field]) ? 1 : ((b[field] < a[field]) ? -1 : 0))
        }
    
        setSortField(field);
        setSortDirection(direction);
      };

      const getDetalle = (item:any)=>{
        const itemIdToExpandedRowMapValues:any = { ...itemIdToExpandedRowMap };
        const reqdata : dataDetalleRequest = {
          IdTipo: tipoContenido,
          IdCentro: item.idCentro
        }
        
        itemIdToExpandedRowMapValues[item.idCentro] = (
          <DetalleContent item={reqdata} onDetalleFilter={onDetalleFilter} onInvalidar={onInvalidar} todosValidados={todosValidados} onValidarCG={onValidarCG} usrDN={usrDN} usrCG={usrCG} validaFinal={validaFinal} tipoContenido={tipoContenido} padreValidado={item.validado}/>
        );
        
        itemIdToExpandedRowMapValues[item.idCentro] && setItemIdToExpandedRowMap(itemIdToExpandedRowMapValues);
    }
  
    const onClickDetalle = (idObj:any) =>{
      console.log('idObj', idObj);
      const itemIdToExpandedRowMapValues:any = { ...itemIdToExpandedRowMap };
      const _found = itemIdToExpandedRowMapValues[idObj.idCentro] ? true : false;
  
      if(_found){
        delete itemIdToExpandedRowMapValues[idObj.idCentro];
        setItemIdToExpandedRowMap(itemIdToExpandedRowMapValues);
      }else{
        getDetalle(idObj);
      }
    }
  
    const getClassRow = (subido:boolean, validado: boolean) =>{
      if( subido && validado){
        return 'rowSuccess';
      }else if (subido){
        return 'rowWarning';
      }else{
        return 'rowError';
      }
    }

      const getRowProps = (item:any) => {
        const { idCentro, subido, validado } = item;
        return {
          'data-test-subj': `row-${idCentro}`,
          className: getClassRow(subido, validado),
          // onClick: () => estado>0 ? onClickDetalle({idImportacion: idImportacion}) : ()=>{},
        };
      };
    
      const sorting:any = {
        sort: {
          field: sortField,
          direction: sortDirection,
        }
      };
console.log('usr CG', usrCG)
    return(
        <EuiBasicTable
            id='tabla-log-importaciones'
            items={data}
            itemId="idCentro"
            columns={columns}
            rowProps={getRowProps}
            onChange={onTableChange}
            sorting={sorting}
            responsive={true}
            itemIdToExpandedRowMap={itemIdToExpandedRowMap}
            isExpandable={true}
            isSelectable
            noItemsMessage
            className='tablaAjustar'
        />
    )
}